import axiosInstance from "./axiosInstance";

// GET notifications
export const fetchNotificationsApi = (page = 1, limit = 10) =>
  axiosInstance.get(`api/notifications?page=${page}&limit=${limit}`);

// GET single notification
export const fetchNotificationByIdApi = (id) =>
  axiosInstance.get(`api/notification/${id}`);

// MARK AS READ
export const markNotificationReadApi = (id) =>
  axiosInstance.patch(`api/notification/read/${id}`);

// DELETE notification
export const deleteNotificationApi = (id) =>
  axiosInstance.delete(`api/notification/delete/${id}`);
